// @ts-nocheck
import { populate } from 'populate';
import type { Container } from 'pixi.js';

const raw = {
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      name: 'root',
      className: 'locaSkin_SPL',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: '9355fba5-a6be-43d6-bf1f-91bd69e8dccf',
      type: 'Sprite',
      name: '',
      className: '',
      x: 143,
      y: -20,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16774312,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'New_Rays',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      stateByName: {
        it_IT: {
          x: 100,
          y: -71,
          scale: {
            x: 0.8,
            y: 0.8
          }
        },
        fr_FR: {
          x: 126,
          y: -69
        },
        de_DE: {
          y: -65,
          scale: {
            x: 0.9,
            y: 0.9
          },
          x: 120
        },
        es_ES: {
          y: -51,
          x: 113
        },
        pt_PT: {
          y: -71,
          x: 126,
          scale: {
            y: 0.9,
            x: 0.9
          }
        },
        pl_PL: {
          y: -67,
          x: 136,
          scale: {
            x: 0.9,
            y: 0.9
          }
        },
        nl_NL: {
          scale: {
            y: 0.9,
            x: 0.9
          },
          y: -63
        },
        ja_JP: {
          x: 72,
          y: -90
        }
      }
    },
    {
      id: 'ec85e26b-b8cb-49b3-ab0f-287cd488c081',
      type: 'Sprite',
      name: '',
      className: '',
      x: 152,
      y: -30,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Coins',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      stateByName: {
        it_IT: {
          visible: true,
          x: -120,
          y: -28
        },
        fr_FR: {
          y: -90,
          x: 122
        },
        de_DE: {
          x: 123,
          y: -77
        },
        es_ES: {
          x: 110,
          y: -87
        },
        pt_PT: {
          x: 127,
          y: -80
        },
        pl_PL: {
          x: 136,
          y: -79
        },
        nl_NL: {
          y: -76,
          x: 140
        },
        ko_KR: {
          y: -34,
          x: 125
        },
        ja_JP: {
          y: -107,
          x: 69
        }
      }
    },
    {
      id: '93e4e95d-2986-46d9-ab76-c476bdd37258',
      type: 'Sprite',
      name: '',
      className: '',
      x: 39,
      y: -3,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Coins',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      stateByName: {
        it_IT: {
          visible: true,
          x: -36,
          y: -34
        },
        fr_FR: {
          anchor: {
            x: 0.7,
            y: 0.9
          }
        },
        de_DE: {
          x: -4,
          y: -67
        },
        es_ES: {
          y: -58,
          x: -3
        },
        pt_PT: {
          y: -51,
          x: -1
        },
        pl_PL: {
          y: -52,
          x: 4
        },
        nl_NL: {
          y: -56,
          x: 12
        },
        ko_KR: {
          y: -53,
          x: -20
        },
        ja_JP: {
          x: 24,
          y: -79
        }
      }
    },
    {
      id: '29c1fe29-8594-4820-ae60-12becc015aca',
      type: 'Sprite',
      name: '',
      className: '',
      x: -99,
      y: -14,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Coins',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      stateByName: {
        it_IT: {
          x: 95,
          y: -72
        },
        fr_FR: {
          x: -118,
          y: -32
        },
        de_DE: {
          x: -135,
          y: -26
        },
        es_ES: {
          y: -8,
          x: -122
        },
        pt_PT: {
          x: -130,
          y: -31
        },
        pl_PL: {
          y: -36,
          x: -126
        },
        nl_NL: {
          x: -119,
          y: -19
        },
        ko_KR: {
          y: -10,
          x: -74
        },
        ja_JP: {
          x: -85,
          y: -58
        }
      }
    },
    {
      id: 'a05ddec4-48ed-42ee-8b49-32466ea11eed',
      type: 'Sprite',
      name: '',
      className: '',
      x: -26,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.6
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 12342016,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Event_Title_Back_Glow',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      stateByName: {
        it_IT: {
          x: 5,
          y: 1,
          angle: -4.4,
          scale: {
            y: 0.418182,
            x: 0.750836
          }
        },
        fr_FR: {
          scale: {
            x: 0.844482,
            y: 0.718182
          },
          y: 20,
          angle: -4.6,
          x: 0
        },
        de_DE: {
          angle: -5.2,
          scale: {
            x: 0.879599
          },
          x: 0,
          y: -4
        },
        es_ES: {
          angle: -4.7,
          scale: {
            y: 0.554545,
            x: 0.610368
          },
          y: -16,
          x: 0
        },
        pt_PT: {
          angle: -5.4,
          x: -4,
          y: -4,
          scale: {
            x: 0.720736,
            y: 0.604545
          }
        },
        pl_PL: {
          angle: -4.8,
          scale: {
            x: 0.782609
          },
          x: -9
        },
        nl_NL: {
          angle: -5.2,
          x: 0,
          y: -6,
          scale: {
            x: 0.83612,
            y: 0.413636
          }
        },
        ko_KR: {
          x: 20,
          y: 17,
          scale: {
            x: 0.797659,
            y: 0.618182
          },
          angle: 10.5
        },
        ja_JP: {
          angle: -4.4,
          x: 0,
          y: -38,
          scale: {
            y: 0.331818
          }
        }
      }
    },
    {
      id: '8e51805f-7c95-4101-8b2a-2ea13e630f72',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 3.3,
        y: 1.1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Piggy_Bank_Tail',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      stateByName: {
        it_IT: {
          x: -58,
          y: 53,
          scale: {
            x: 0.8,
            y: 0.8
          }
        },
        fr_FR: {
          x: -13,
          y: 65
        },
        de_DE: {
          y: 64,
          x: -47
        },
        es_ES: {
          x: -20,
          y: 61
        },
        pt_PT: {
          x: -25,
          y: 60
        },
        pl_PL: {
          x: -37,
          y: 62
        },
        nl_NL: {
          y: 61,
          x: -32
        },
        ko_KR: {
          y: -31
        },
        ja_JP: {
          x: 36,
          y: 55
        }
      }
    },
    {
      id: '8e728919-e16f-4649-95f1-1c3878a695aa',
      type: 'Text',
      name: '',
      className: '',
      x: -51,
      y: -55,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: -5,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'PIGGY',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 120,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: '#ff8285',
        stroke: '#ffeeef',
        strokeThickness: 20,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 1,
        dropShadowBlur: 0,
        dropShadowColor: '#ffb4b8',
        dropShadowDistance: 10,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 0,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      stateByName: {
        it_IT: {
          text: 'SALVADANAIO',
          style: {
            fontSize: 70,
            strokeThickness: 15,
            dropShadowAngle: 2,
            dropShadowDistance: 7
          },
          x: 0,
          y: 0
        },
        fr_FR: {
          text: 'TIRELIRE',
          x: 0,
          y: 0,
          style: {
            dropShadowAngle: 1.7
          }
        },
        de_DE: {
          text: 'SPARSCHWEIN',
          x: 0,
          y: 0,
          style: {
            fontSize: 80,
            dropShadowAngle: 1.4
          }
        },
        es_ES: {
          text: 'HUCHA',
          x: 0,
          y: 0,
          scale: {
            x: 1.2,
            y: 1.2
          },
          style: {
            dropShadowAngle: 1.6
          }
        },
        pt_PT: {
          text: 'COFRINHO',
          x: 0,
          y: 0,
          style: {
            fontSize: 100,
            dropShadowAngle: 1.7
          }
        },
        pl_PL: {
          text: 'SKARBONKA',
          x: 0,
          y: 0,
          style: {
            fontSize: 88,
            dropShadowAngle: 1.4
          }
        },
        nl_NL: {
          x: 0,
          y: 0,
          text: 'SPAARVARKEN',
          style: {
            fontSize: 74,
            dropShadowAngle: 1.6,
            stroke: '#ffeeef',
            strokeThickness: 15,
            dropShadowDistance: 8
          }
        },
        ko_KR: {
          text: '돼지',
          style: {
            fontWeight: 'bolder',
            fontSize: 110,
            stroke: '#ffeeef'
          },
          y: -74,
          x: -106
        },
        ja_JP: {
          text: '貯金箱',
          style: {
            fontWeight: 'bolder'
          },
          x: 0,
          y: 0
        }
      }
    },
    {
      id: '9ef0fe7f-df57-4b68-9023-feed331e5ddc',
      type: 'Text',
      name: '',
      className: '',
      x: 105,
      y: 40,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 5,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'BANK',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 120,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: '#ffa800',
        stroke: '#fff8d9',
        strokeThickness: 20,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 2,
        dropShadowBlur: 0,
        dropShadowColor: '#d29974',
        dropShadowDistance: 10,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 0,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      stateByName: {
        it_IT: {
          visible: false
        },
        fr_FR: {
          visible: false
        },
        de_DE: {
          visible: false
        },
        es_ES: {
          visible: false
        },
        pt_PT: {
          visible: false
        },
        pl_PL: {
          visible: false
        },
        nl_NL: {
          visible: false
        },
        ko_KR: {
          visible: true,
          text: '저금통',
          style: {
            fontWeight: 'bolder',
            fontSize: 110
          }
        },
        ja_JP: {
          visible: false
        }
      }
    },
    {
      id: 'ba64b558-562a-44e2-8e41-eaaa00d98fa1',
      type: 'Sprite',
      name: '',
      className: '',
      x: 180,
      y: -87,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 2,
        y: 2
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Sparkle_Yellow',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      stateByName: {
        it_IT: {
          x: 138,
          y: -129
        },
        fr_FR: {
          x: 140,
          y: -148
        },
        de_DE: {
          x: 148,
          y: -139
        },
        es_ES: {
          anchor: {
            y: 1.3,
            x: 1.1
          }
        },
        pt_PT: {
          x: 142,
          y: -140
        },
        pl_PL: {
          x: 158,
          y: -137
        },
        nl_NL: {
          y: -134,
          x: 165
        },
        ko_KR: {
          x: 153,
          y: -92
        },
        ja_JP: {
          y: -165,
          x: 98
        }
      }
    },
    {
      id: 'b725e15d-18d7-4c8f-904e-cf8090182d76',
      type: 'Sprite',
      name: '',
      className: '',
      x: 169,
      y: -23,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.3,
        y: 1.3
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Sparkle_Yellow',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      stateByName: {
        it_IT: {
          x: 67,
          y: -74
        },
        fr_FR: {
          x: 121,
          y: -80
        },
        de_DE: {
          x: 181,
          y: -70
        },
        es_ES: {
          y: -90,
          x: 79
        },
        pt_PT: {
          x: 180,
          y: -72
        },
        pl_PL: {
          anchor: {
            y: 2,
            x: 2.9
          }
        },
        nl_NL: {
          y: -96,
          x: 105
        },
        ko_KR: {
          x: 88,
          y: -56
        },
        ja_JP: {
          y: -125,
          x: 44
        }
      }
    }
  ],
  x: 0,
  y: 0,
  width: 664,
  height: 667,
  version: '1.0.0',
  stateNames: [
    'en_US',
    'it_IT',
    'fr_FR',
    'de_DE',
    'es_ES',
    'pt_PT',
    'pl_PL',
    'nl_NL',
    'ko_KR',
    'ja_JP'
  ],
  handleResize: false
} as const;

export class PiggyBankTitleLocalizationsLayout {
  static raw = raw;
  root!: Container;
  locaSkin_SPL!: (Container)[];
  StateName!: 'en_US' | 'it_IT' | 'fr_FR' | 'de_DE' | 'es_ES' | 'pt_PT' | 'pl_PL' | 'nl_NL' | 'ko_KR' | 'ja_JP';

  constructor() {
    populate(this, raw);
  }
}
